"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MappingConvert = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _bignumber = _interopRequireDefault(require("bignumber.js"));
class MappingConvert {
  constructor() {
    (0, _defineProperty2.default)(this, "type", "mapping");
    (0, _defineProperty2.default)(this, "label", "Mapping");
    (0, _defineProperty2.default)(this, "description", "Convert values based on a predetermined mapping.");
    (0, _defineProperty2.default)(this, "settings", {
      values: {
        type: "mapping",
        title: "Mapping Values",
        description: "Specify how to convert the values on the left to the right."
      }
    });
  }
  dependencies(context, params, resolver) {
    return params;
  }
  create(deps, batcher) {
    if (!(deps !== null && deps !== void 0 && deps.values)) {
      return value => value;
    }
    let testers = deps.values.map(it => {
      let numValue = new _bignumber.default(it.from).toNumber();
      return {
        test: value => {
          var _it$from, _it$from2;
          if (typeof value === "string") {
            return value === it.from;
          }
          if (typeof value === "number") {
            return value === numValue;
          }
          return value === (((_it$from = it.from) === null || _it$from === void 0 ? void 0 : _it$from.toLowerCase()) === "true" || ((_it$from2 = it.from) === null || _it$from2 === void 0 ? void 0 : _it$from2.toLowerCase()) === "yes");
        },
        to: it.to
      };
    });
    return value => {
      if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
        let i = 0;
        for (let it of testers) {
          if (it.test(value)) {
            return it.to;
          }
          ++i;
        }
      }
      return value;
    };
  }
  editorLabel(params) {
    if (!params.values || params.values.length === 0) {
      return "no values";
    }
    return `${params.values.length} values`;
  }
}
exports.MappingConvert = MappingConvert;
//# sourceMappingURL=MappingConvert.js.map